<!-- DesktopShell Template - Feature: 012-desktop-mobile-shells -->
<div class="desktop-shell">
  <!-- Skip Link for Accessibility -->
  <a href="#main-content" class="skip-link" [attr.aria-label]="'SHELL.SKIP_TO_CONTENT' | translate">
    {{ 'SHELL.SKIP_TO_CONTENT' | translate }}
  </a>

  <!-- Header -->
  <app-header></app-header>

  <!-- Main Layout: Sidebar + Content -->
  <div class="desktop-shell__body">
    <!-- Sidebar Navigation -->
    <aside class="desktop-shell__sidebar" role="navigation" [attr.aria-label]="'SHELL.SIDEBAR_NAVIGATION' | translate">
      <app-sidebar></app-sidebar>
    </aside>

    <!-- Main Content Area -->
    <main id="main-content" class="desktop-shell__content" role="main" tabindex="-1">
      <div class="desktop-shell__content-inner">
        <ng-content></ng-content>
      </div>
    </main>
  </div>
</div>
